import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { messageNotificationCircle, xIcon } from 'src/app/sharedcomp/constans/icons.constans';

@Component({
  selector: 'ngbd-modal-content',
  styles: [`

    .modal--v2 {
      padding: var(--spacing-3xl, 24px)
    }

    .modal__background-pattern--v2 {
      background-image: url('../../../../../assets/new-icons/background-pattern-decorative.svg');
      background-color: transparent;
      background-repeat: no-repeat;
      height: 100%;
      width: 100%;
      position: absolute;
      overflow: hidden;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .modal-header--v2, .modal__body--v2, .modal__footer--v2 {
      z-index: 2;
      position: relative;
    }

    .modal-header--v2 {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .modal-header__image-container {
      width: 48px;
      height: 48px;
      padding: 12px;
      border-radius: var(--radius-lg, 10px);
      border: 1px solid var(--colors-border-secondary, #EAECF0);
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    }

    .modal-header__button--reject {
      background-color: transparent;
      border: 0;
    }

    .modal__body--v2 {
      padding-top: var(--spacing-xl, 16px);
    }

    .modal__body-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--spacing-xs, 4px);
      align-self: stretch;
    }

    .modal__body-text p, .modal__body-text h1 {
      margin: 0;
    }

    .modal__body-text h1 {
      color: var(--colors-text-primary-900, #101828);
      font-size: 1.125rem;
      font-weight: 700;
      line-height: 1.75rem;
    }

    .modal__body-text p {
      color: var(--colors-text-tertiary-600, #475467);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .modal__footer--v2 {
      display: flex;
      align-items: flex-start;
      gap: var(--spacing-lg, 12px);
      align-self: stretch;
      padding-top: 20px;
    }

    .modal__button {
      padding: 10px var(--spacing-xl, 16px);
      flex: 1 0 0;
    }

    .modal__button--reject {
      border-radius: var(--radius-md, 8px);
      border: 1px solid var(--colors-border-primary, #D0D5DD);
      background: var(--colors-background-bg-primary, #FFF);
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

      color: var(--colors-text-secondary-700, #344054);
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.5rem;
    }

    .modal__button--accept {
      border-radius: var(--radius-md, 8px);
      border: 1px solid var(--primary-dark-0, #0666EB);
      background: var(--primary-dark-00, #0666EB);
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

      color: var(--colors-background-bg-primary, #FFF);
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.5rem;
    }

  `],
  template: `
  <div class="modal--v2">

    <div class="modal__background-pattern--v2"></div>

    <div class="modal-header--v2">
      <div class="modal-header__image-container">
        <img class="modal-header__image" [src]="icons.messageNotificacion.path" [alt]="icons.messageNotificacion.alt">
      </div>
      <button type="button" class="modal-header__button modal-header__button--reject" aria-label="Close" (click)="activeModal.dismiss('Dismiss')">
        <img class="modal-header__button-icon" [src]="icons.x.path" [alt]="icons.x.alt">
      </button>
    </div>

    <div class="modal__body--v2">
      <div class="modal__body-text">
        <h1>{{bodyTextTittle}}</h1>
        <p>{{bodyTextParagraph}}</p>
      </div>
    </div>

    <div class="modal__footer--v2">
      <button type="button" class="modal__button modal__button--reject" (click)="activeModal.dismiss('Dismiss')">{{dismissButton}}</button>
      <button type="button" class="modal__button modal__button--accept" (click)="activeModal.close('Accept')">{{acceptButton}}</button>
    </div>
  </div>

  `
})

export class NgbdModalContent {
  @Input() bodyTextTittle: string;
  @Input() bodyTextParagraph: string;
  @Input() dismissButton: string;
  @Input() acceptButton: string;

  icons: Record<string, { path: string; alt: string }>;

  constructor(public activeModal: NgbActiveModal) {
    this.icons = this.setIcons();
  }

  setIcons() {
    return {
      x: xIcon,
      messageNotificacion: messageNotificationCircle
    };
  }
}
